import script from "./ModalOpener.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ModalOpener.vue?vue&type=script&lang=ts"
export * from "./ModalOpener.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ModalOpener.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__